import { render, staticRenderFns } from "./objectComplianceReport.vue?vue&type=template&id=37d06622&scoped=true"
import script from "./objectComplianceReport.vue?vue&type=script&lang=js"
export * from "./objectComplianceReport.vue?vue&type=script&lang=js"
import style0 from "./objectComplianceReport.vue?vue&type=style&index=0&id=37d06622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d06622",
  null
  
)

export default component.exports